import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export enum ContentTypeEnum {
  employees = 'employees',
  phone_plans = 'phone_plans',
  rentals = 'rentals',
  stocklist_items = 'stocklist_items',
  invoices = 'invoices',
  caseitems = 'caseitems',
  depots = 'depots',
}

export interface PortalContentModelItem {
  icon: IconDefinition
  translationId: string
  path: string
  modelType: `${ContentTypeEnum}`
}

export type PortalContentModel = {
  [key: string]: PortalContentModelItem
}
